import { Tabs as TabsAntd } from "antd";
import styles from "./Tabs.module.scss";
import type { TabsProps as TabsAntdProps } from "antd";

const Tabs = (TabsProps: TabsAntdProps) => {
  return (
    <TabsAntd
      {...TabsProps}
      className={[styles.Tabs, TabsProps.className].join(" ")}
    />
  );
};

export { Tabs };
